import TherapeuticPlanResume from 'presentation/doctor/pages/AddTherapeuticPlan/TherapeuticPlanResume'
import React from 'react'

export default function makeDoctorTherapeuticPlanResume() {
  return <TherapeuticPlanResume />
}
